<div class="container-info-facultad">
   <div class="width-paginate title-container-facultad">
      <div class="icono-facultad">
         <img [src]="info?.venue?.icono" alt="">
      </div>
      <div class="title-facultad">
         <h1 class="quicksand-bold"> {{ info?.venue?.title }}</h1>
         <h2 class="quicksand-medium">Sede <strong> {{ info?.venue?.sede }} </strong> </h2>
      </div>
   </div>
   <div class="width-paginate title-card" [style.background-color]="info?.venue?.color">
      <h3 class="quicksand-bold">NUESTRA FACULTAD</h3>
   </div>
   <div class="width-paginate  content-facultad">
      <div class="content1">
         <div class="html" [innerHTML]="info?.venue?.description | sanitizeHtml"></div>
         <hr class="divider">
         <div class="buttons">
            <button *ngIf="info?.ourVenue?.verMasUrl" class="btn-white-f nunito-medium zoomIn"
               (click)="goToUrl(info?.ourVenue?.verMasUrl)" [style.border-color]="info?.venue?.color">+ INFO</button>
            <button *ngIf="info?.ourVenue?.authorities?.length > 0" class="btn-color-f nunito-medium zoomIn"
               [style.border-color]="info?.venue?.color" [style.background-color]="info?.venue?.color"
               (click)="abrirModalAutoridades()">AUTORIDADES</button>
         </div>

         <div class="modal-overlay" *ngIf="isModalOpen">
            <div class="modal-container">
               <img class="close-modal-btn" (click)="cerrarModalAutoridades()" src="./assets/img/close.png" alt="Cerrar autoridades">
               <app-facultad-autoridades [autoridadesLista]="info?.ourVenue?.authorities"  [autoridadPrincipal]="info?.ourVenue?.dean"
                  [color]="info?.venue?.color"></app-facultad-autoridades>
            </div>
         </div>
         <div class="dropdown-container" *ngIf="info?.ourVenue?.departments && info?.ourVenue?.departments?.length > 0">

            <button class="dropdown-header"  [style.background-color]="info?.venue?.color" [class.active]="isOpen" (click)="toggleDropdown($event)" type="button">
               <span class="nunito-bold">DEPARTAMENTOS</span>
               <img src="./assets/img/flechita-blanca.svg" class="icon-arrow" alt="Flecha desplegable" />
            </button>

            <!-- LISTA DESPLEGABLE -->
            <div class="dropdown-menu" *ngIf="isOpen">
               <ul>
                  <li *ngFor="let depto of info?.ourVenue.departments" class="nunito-bold">
                     <a [href]="'/es' + depto.link" target="_blank" rel="noopener noreferrer">
                        {{ depto.title }}
                     </a>
                  </li>
               </ul>
            </div>

         </div>
      </div>
      <div class="content2">
         <h2 class="quicksand-bold" [style.color]="'#003A73'">Contacto</h2>
         <div class="content2-item">
            <img src="./assets/facultades/clock.png" alt="">
            <div class="content2-texts">
               <span class="nunito-bold">Horario de atención</span>
               <p class="ninuto-mediun">
                  {{ info?.venue?.diasDesde === 'Lunes' ? 'Lun' : info?.venue?.diasDesde === 'Martes' ? 'Mar' : info?.venue?.diasDesde === 'Miércoles' ? 'Mier' : info?.venue?.diasDesde === 'Jueves' ? 'Jue' : info?.venue?.diasDesde === 'Viernes' ? 'Vier' : info?.venue?.diasDesde }}
                  a
                  {{ info?.venue?.diasHasta === 'Lunes' ? 'Lun' : info?.venue?.diasHasta === 'Martes' ? 'Mar' : info?.venue?.diasHasta === 'Miércoles' ? 'Mier' : info?.venue?.diasHasta === 'Jueves' ? 'Jue' : info?.venue?.diasHasta === 'Viernes' ? 'Vier' : info?.venue?.diasHasta }}
                  de {{ info?.venue?.horaDesde }} a {{ info?.venue?.horaHasta }}hs
               </p>
            </div>
         </div>
         <div class="content2-item">
            <img src="./assets/facultades/location.png" alt="">
            <div class="content2-texts">
               <span class="nunito-bold">Dirección</span>
               <a 
                       [href]="info?.venue?.mapsUrl"
                       target="_blank" 
                       rel="noopener noreferrer" 
                       class="ninuto-mediun">
                         <p class="ninuto-medium"> {{ info?.venue?.address }}</p>
                 </a>
            </div>
         </div>
         <div class="content2-item">
            <img src="./assets/facultades/email.png" alt="">
            <div class="content2-texts">
               <span class="nunito-bold">E-mail</span>
                <a  [href]="'mailto:' +  info?.venue?.email"  class="ninuto-medium">
         <p class="ninuto-medium"> {{ info?.venue?.email }}</p>
      </a>
            </div>
         </div>
         <div class="redes-facultad" *ngIf="info?.venue?.facebookUrl || info?.venue?.igUrl || info?.venue?.linkedinUrl || info?.venue?.twitterUrl
         || info?.venue?.tiktokUrl || info?.venue?.youtubeUrl">
            <h2 class="nunito-bold">Nuestras redes</h2>
            <div class="iconos-redes">
               <!-- Facebook -->
               <a *ngIf="info?.venue?.facebookUrl" [href]="info?.venue?.facebookUrl" target="_blank"
                  rel="noopener noreferrer">
                  <img src="./assets/img/facebook5.png" alt="Facebook">
               </a>

               <!-- Instagram -->
               <a *ngIf="info?.venue?.igUrl" [href]="info?.venue?.igUrl" target="_blank"
                  rel="noopener noreferrer">
                  <img src="./assets/img/instagram2.png" alt="Instagram">
               </a>

               <!-- LinkedIn -->
               <a *ngIf="info?.venue?.linkedinUrl" [href]="info?.venue?.linkedinUrl" target="_blank"
                  rel="noopener noreferrer">
                  <img src="./assets/img/in2.png" alt="LinkedIn">
               </a>

               <!-- Twitter / X -->
               <a *ngIf="info?.venue?.twitterUrl" [href]="info?.venue?.twitterUrl" target="_blank"
                  rel="noopener noreferrer">
                  <img src="./assets/img/X2.png" alt="X / Twitter">
               </a>

               <!-- TikTok -->
               <a *ngIf="info?.venue?.tiktokUrl" [href]="info?.venue?.tiktokUrl" target="_blank"
                  rel="noopener noreferrer">
                  <img src="./assets/img/tiktok2.png" alt="TikTok">
               </a>

               <!-- YouTube -->
               <a *ngIf="info?.venue?.youtubeUrl" [href]="info?.venue?.youtubeUrl" target="_blank"
                  rel="noopener noreferrer">
                  <img src="./assets/img/youtube2.png" alt="YouTube">
               </a>
            </div>
         </div>
      </div>
      <div class="content3"  [style.max-height.px]="alturaInicial">
         <app-instagram-post  [post]="(info?.ourVenue?.instagramLatestPost)? info?.ourVenue?.instagramLatestPost[0] : null"></app-instagram-post>
      </div>
   </div>
</div>
